import React from 'react';
import { FormattedMessage } from 'react-intl-next';
import { QuickFindDataProduct } from '@atlassian/search-client';
import Lozenge from '@atlaskit/lozenge';
import { Box, xcss } from '@atlaskit/primitives';
import { EventTypeMessage } from './event-type-message';
import { messages } from '../../messages';
import { ContentIconRenderer } from './content-icon-renderer';
import { ConfluenceResultMeta } from './confluence-result-meta';
import { QuickFindResultMeta, capitalizeFirstLetter } from './quick-find-meta';
var CONTEXT_PATH = '/wiki';
var labelStyles = xcss({
  marginInlineStart: 'space.050'
});
export var quickFindRecentItemResultMapper = function quickFindRecentItemResultMapper(edge) {
  var _$node, _data$fieldsById, _data$links, _data$links2, _data$space;
  var item = edge.node;
  var data = item.object.data;
  var productType = item.object.product;
  switch (productType) {
    case QuickFindDataProduct.JIRA:
      return {
        id: item.object.id,
        title: "".concat(data === null || data === void 0 ? void 0 : data.key, ": ").concat((_$node = ((data === null || data === void 0 || (_data$fieldsById = data.fieldsById) === null || _data$fieldsById === void 0 ? void 0 : _data$fieldsById.edges) || [{}])[0].node) === null || _$node === void 0 ? void 0 : _$node.text) || '',
        url: (data === null || data === void 0 ? void 0 : data.webUrl) || '',
        icon: ContentIconRenderer({
          type: 'jira',
          title: data === null || data === void 0 ? void 0 : data.title
        }),
        meta: /*#__PURE__*/React.createElement(QuickFindResultMeta, {
          meta: ['Jira', capitalizeFirstLetter(item.object.type)]
        }),
        additionalMeta: /*#__PURE__*/React.createElement(EventTypeMessage, {
          timestamp: item.event.timestamp,
          eventType: item.event.eventType
        }),
        isRecentResult: true,
        type: "".concat(item.object.product, " ").concat(item.object.type)
      };
    case QuickFindDataProduct.CONFLUENCE:
      // Do NOT show drafts for live-edit pages since they're not drafts from a user perspective
      var isDraft = ((data === null || data === void 0 ? void 0 : data.pageStatus) === 'DRAFT' || (data === null || data === void 0 ? void 0 : data.blogStatus) === 'DRAFT') && (data === null || data === void 0 ? void 0 : data.subtype) !== 'LIVE';
      return {
        ari: item.object.id,
        id: item.object.id,
        title: (data === null || data === void 0 ? void 0 : data.title) || '',
        url: "".concat((data === null || data === void 0 || (_data$links = data.links) === null || _data$links === void 0 ? void 0 : _data$links.base) || CONTEXT_PATH).concat(data === null || data === void 0 || (_data$links2 = data.links) === null || _data$links2 === void 0 ? void 0 : _data$links2.webUi),
        icon: ContentIconRenderer({
          type: item.object.type,
          title: data === null || data === void 0 ? void 0 : data.title,
          isDraft: isDraft
        }),
        label: isDraft ? /*#__PURE__*/React.createElement(Box, {
          xcss: labelStyles,
          as: "span"
        }, /*#__PURE__*/React.createElement(Lozenge, null, /*#__PURE__*/React.createElement(FormattedMessage, messages.quick_find_recent_draft_label))) : '',
        meta: /*#__PURE__*/React.createElement(ConfluenceResultMeta, {
          resultContentType: item.object.type,
          resultAncestors: data === null || data === void 0 ? void 0 : data.ancestors,
          resultSpace: data === null || data === void 0 ? void 0 : data.space
        }),
        additionalMeta: /*#__PURE__*/React.createElement(EventTypeMessage, {
          timestamp: item.event.timestamp,
          eventType: item.event.eventType
        }),
        isRecentResult: true,
        type: "".concat(item.object.product, " ").concat(item.object.type),
        containerId: (data === null || data === void 0 || (_data$space = data.space) === null || _data$space === void 0 ? void 0 : _data$space.id) || undefined
      };
    case QuickFindDataProduct.ATLAS:
      return {
        id: item.object.id,
        title: "".concat(data === null || data === void 0 ? void 0 : data.name) || '',
        url: (data === null || data === void 0 ? void 0 : data.url) || '',
        icon: ContentIconRenderer({
          type: 'atlas',
          imageSrc: (data === null || data === void 0 ? void 0 : data.iconData) || '',
          title: data === null || data === void 0 ? void 0 : data.title
        }),
        meta: /*#__PURE__*/React.createElement(QuickFindResultMeta, {
          meta: [capitalizeFirstLetter(item.object.type), data === null || data === void 0 ? void 0 : data.key]
        }),
        additionalMeta: /*#__PURE__*/React.createElement(EventTypeMessage, {
          timestamp: item.event.timestamp,
          eventType: item.event.eventType
        }),
        isRecentResult: true,
        type: "".concat(item.object.product, " ").concat(item.object.type)
      };
    default:
      return {
        id: '',
        title: '',
        url: '',
        icon: '',
        meta: ''
      };
  }
};